import { render, staticRenderFns } from "./UsersPrivilegeRevenus.vue?vue&type=template&id=050ac7ee&scoped=true&"
import script from "./UsersPrivilegeRevenus.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeRevenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ac7ee",
  null
  
)

export default component.exports